'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.switch-bg {\n  background: #0b1821;\n}\n\n.switch-border {\n  border: #0a2c42 solid 7px !important;\n}\n\n#switch__checkbox {\n  z-index: -10;\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: none;\n}\n\n.switch__wrapper {\n  display: flex;\n  align-items: center;\n  margin: calc(0.75 * 1rem);\n}\n\n.switch {\n  position: relative;\n  z-index: 99;\n  overflow: hidden;\n  width: 60px;\n  height: 24px;\n  border-radius: 45px;\n  border: 2px solid #f29393;\n  background-color: #f29393;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.switch__label {\n  overflow: hidden;\n  z-index: 10;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  margin-bottom: 0;\n}\n.switch__circle {\n  position: absolute;\n  z-index: 10;\n  width: 20px;\n  height: 20px;\n  background: #fff;\n  border: 2px solid #e52c2c;\n  border-radius: 50%;\n  top: 0;\n  left: 0;\n  transition: all 0.3s ease-in-out;\n}\n#switch__checkbox:checked ~ .switch__label .switch__circle {\n  transform: translateX(107px);\n  background: #fff;\n  left: -70px;\n  background-color: #ffffff;\n  border: 2px solid #1ec494;\n}\n.switch__circle .switch {\n  background-color: #78dcbf;\n}\n\n.switch__text {\n  color: #b5cdf4;\n  margin-left: calc(0.75 * 1rem);\n  align-self: center;\n}\n\n.switch-off {\n  border: 2px solid #f29393;\n  background-color: #f29393;\n}\n\n.switch-on {\n  border: 2px solid #78dcbf;\n  background-color: #78dcbf;\n}");
//# sourceMappingURL=Switch.scss.js.map
